<template>
    <div></div>
</template>

<script>
export default {
    name: 'cloud-eh',
    methods: {
    },
    mounted() {
        window.open(window.location.origin + '/cloud-eh/index.html', '_blank');
        this.$router.back();
    },
};
</script>
